import React, { Suspense, lazy } from 'react';
import { Redirect } from 'react-router-dom';

/* 
<Router>
<Suspense fallback={<div>Loading...</div>}>
  <Routes>
    <Route path="/" element={<Home />} />
    <Route path="/about" element={<About />} />
  </Routes>
</Suspense>
</Router>
 */

//Dashboards
/* import Dashboard from "../pages/Dashboard";
import DashboardPW from "../pages/DashboardPW"; */

//AuthenticationInner pages
import PageLogin from '../pages/AuthenticationInner/PageLogin';
import PageRegister from '../pages/AuthenticationInner/PageRegister';
import RecoverPassword from '../pages/AuthenticationInner/RecoverPassword';
import LockScreen from '../pages/AuthenticationInner/LockScreen';
import ConfirmMail from '../pages/AuthenticationInner/ConfirmMail';
import EmailVerification from '../pages/AuthenticationInner/EmailVerification';
import TwoStepVerfication from '../pages/AuthenticationInner/TwoStepVerfication';

//Authentication pages
import Login from '../pages/Authentication/Login';
import Demo from '../pages/Authentication/Demo';
import Logout from '../pages/Authentication/Logout';
import Register from '../pages/Authentication/Register';
import userProfile from '../pages/Authentication/user-profile';

import { Traceabilities as Traceabilitiesv2 } from '../pages/TraceabilitiesV2/Traceabilities';
import { Traceabilities } from '../pages/Traceabilities/Traceabilities';
import { Notifications } from '../pages/Notifications/Notifications';
import ClientList from '../pages/client/clients-list';
import MilestonesList from '../pages/milestones/milestone-list';
import clientDetails from '../pages/client/client-details';

//Invoice
import InvoiceList from '../components/invoice-list';
import ItemDefinitions from '../pages/ItemsDefinitions/item-definitions';

import Home from '../pages/Home';
import InactiveUsers from '../pages/Users/users-list';
import SalesOrder from '../pages/salesOrderList/SalesOrder';

import WharehouseReceipt from '../pages/wharehouseReceiptList/WharehouseReceipt';
import CargoRelease from '../pages/cargoReleaseList/CargoRelease';
import PurchaseOrders from '../pages/purchaseOrdersList/PurchaseOrders';
import Commodity from '../pages/commodityList/Commodity';
import ApiList from '../pages/Administration/Api/ApiList';

import PermissionsList from '../pages/Administration/Permissions/Permissions-list';
import TasksList from '../pages/Administration/Tasks/Tasks-list';
import RolMenu from '../pages/Administration/Rol-Menu/Rol-Menu-list';
import RolesList from '../pages/Administration/Roles/roles-lists';
import UsersList from '../pages/Administration/Users/Users-list';
import ConfigTaskList from '../pages/Administration/ConfigTasks/configTask-lists';
import BrandCustomList from '../pages/Administration/BrandCustom/BrandCustom_List';
import Entities from '../pages/Entities/EntitiesList';
import { SyncConfigList } from '../pages/SyncConfig/SyncConfigLists';
import Support from '../pages/support/Support';
import Shipments from '../pages/shipmentList/Shipments';
import PickupOrders from '../pages/pickupOrdersList/PickupOrders';
import SummaryImport from '../pages/summaryImport/SummaryImport';
import LoadFile from '../pages/LoadFile/LoadFile';
import DashboardHollistics from '../pages/DashboardHollistics/DashboardHollistics';
import CrCreation from '../pages/crCreation/CrCreation';
import OauthToken from '../pages/OauthToken/OauthToken';
import GenericHollistics from '../pages/GenericHollistics/GenericHollistics';
import Iframe from '../pages/Iframe/Iframe';

import MilestonesTrackingConfig from '../pages/MilestonesTrackingConfig/MilestonesTrackingConfig';
import ConfigReportPODForm from '../pages/ConfigReports/configPOD';
import Invoices from '../pages/InvoicesList/Invoices';
import Quotes from '../pages/QuotesList/Quotes';
import Bookings from '../pages/BookingsList/Bookings';

const Dashboard = lazy(() => import('../pages/Dashboard'));
const DashboardPW = lazy(() => import('../pages/DashboardPW'));

interface RouteProps {
  path: string;
  component: any;
  exact?: boolean;
}

const userRoutes: Array<RouteProps> = [
  { path: '/profile', component: userProfile },
  { path: '/clients', component: ClientList },
  { path: '/VisibilityConfiguration', component: MilestonesList },
  { path: '/inactiveUsers', component: InactiveUsers },
  { path: '/apiList', component: ApiList },
  // Listas de operaciones: código de transacción de Magaya (Transaction Types de su API) + "List".
  // Las rutas viejas redirigen para no romper favoritos; el menú y el título salen de iPermiso.url_menu.
  { path: '/SOList', component: SalesOrder },
  { path: '/SHList', component: Shipments },
  { path: '/WHList', component: WharehouseReceipt },
  { path: '/CRList', component: CargoRelease },
  { path: '/POList', component: PurchaseOrders },
  { path: '/PKList', component: PickupOrders },
  { path: '/WIList', component: Commodity },
  { path: '/IVList', component: ItemDefinitions },
  { path: '/INList', component: Invoices },
  { path: '/QTList', component: Quotes },
  { path: '/BKList', component: Bookings },
  { path: '/WRList', component: () => <Redirect to="/WHList" /> },
  { path: '/CommodityList', component: () => <Redirect to="/WIList" /> },
  { path: '/itemDefinitions', component: () => <Redirect to="/IVList" /> },
  { path: '/Invoices', component: () => <Redirect to="/INList" /> },
  { path: '/Quotes', component: () => <Redirect to="/QTList" /> },
  { path: '/Bookings', component: () => <Redirect to="/BKList" /> },
  { path: '/Home', component: Home },
  { path: '/Visibility', component: PermissionsList },
  { path: '/Tasks', component: TasksList },
  { path: '/RolMenu', component: RolMenu },
  { path: '/Roles', component: RolesList },
  { path: '/Users', component: UsersList },
  { path: '/ConfigTask', component: ConfigTaskList },
  { path: '/customBrand', component: BrandCustomList },
  { path: '/Entities', component: Entities },
  { path: '/traceabilitiesv2', component: Traceabilitiesv2 },
  { path: '/notifications', component: Notifications },
  { path: '/syncconfig', component: SyncConfigList },
  { path: '/support', component: Support },
  { path: '/SummaryImport', component: SummaryImport },
  { path: '/loadFile', component: LoadFile },
  { path: '/Intelligence_hub_SO', component: DashboardHollistics },
  { path: '/MilestonesTrackingConfig', component: MilestonesTrackingConfig },
  { path: '/ConfigReportPOD', component: ConfigReportPODForm },

  // Contenido embebido (dashboards de BI, docs y páginas de cada empresa): la URL no dice de dónde viene.
  // Las rutas viejas redirigen para no romper enlaces guardados.
  { path: '/Analytics/:id', component: GenericHollistics },
  { path: '/GenericHollistics/:id', component: (p: any) => <Redirect to={'/Analytics/' + p.match.params.id} /> },
  { path: '/Pages/:id', component: Iframe },
  { path: '/Iframe/:id', component: (p: any) => <Redirect to={'/Pages/' + p.match.params.id} /> },
  /* { path: '/Intelligence_hub_PO', component: DashboardHollistics },
  { path: '/Intelligence_hub_PK', component: DashboardHollistics },
  { path: '/Intelligence_hub_WR', component: DashboardHollistics }, */

  { path: '/cargoRelease', component: CrCreation },
  // this route should be at the end of all other routes
  { path: '/', exact: true, component: () => <Redirect to="/Home" /> },
];

const dashBoardsRoutes: Array<RouteProps> = [
  { path: '/dashboard', component: Dashboard },
  { path: '/dashboardPW', component: DashboardPW },
];

const clientRoutes = [
  { path: '/traceabilities', component: Traceabilities },
  { path: '/clients-details', component: clientDetails },
  { path: '/', exact: true, component: () => <Redirect to="/Home" /> },
  { path: '/invoices-list', component: InvoiceList },
];
const authRoutes: Array<RouteProps> = [
  //Authentication pages
  { path: '/login', component: Login },
  { path: '/demo', component: Demo },
  { path: '/logout', component: Logout },
  { path: '/register', component: Register },


  //AuthenticationInner pages
  { path: '/page-login', component: PageLogin },
  { path: '/page-register', component: PageRegister },
  { path: '/auth-recoverpw', component: RecoverPassword },
  { path: '/page-lock-screen', component: LockScreen },
  { path: '/page-confirm-mail', component: ConfirmMail },
  { path: '/page-email-verification', component: EmailVerification },

  { path: '/OauthCallBack', component: OauthToken },
];

export { userRoutes, authRoutes, clientRoutes, dashBoardsRoutes };
